import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import ItineraryIncidentSearchForm from './ItineraryIncidentSearchForm';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import {
  clearItinerarySegment,
  getItinerarySegment,
} from '../../../../actions/supervision-control';
import { ITINERARY_SEGMENT_COLUMNS } from '../../../../config/columns';
import { ITINERARY_INCIDENT_PATH } from '../../../../config/paths';

const INITIAL_SEARCH_FORM_VALUES = {
  dateString: tzNormalizeDate(),
};

const ItineraryIncidents = ({
  breadcrumbs,
  dispatchGetItinerarySegment,
  itinerarySegment,
  dispatchClearItinerarySegment,
  loading,
  dispatchPush,
}) => {
  useLayoutEffect(() => () => dispatchClearItinerarySegment(), []);

  const onSubmit = (formValues, locationType) => {
    const { location, dateString } = formValues;

    if (!location) {
      toastr.warning('Validación', 'Debe seleccionar una ubicación');
      return;
    }

    const locationId = location.value;

    const searchParams = {
      sourceLocationId: locationType === 'source' ? locationId : undefined,
      destinationLocationId:
        locationType === 'destination' ? locationId : undefined,
      dateString: tzNormalizeDate({
        date: dateString,
        format: INT_DATE_FORMAT,
      }),
    };

    dispatchGetItinerarySegment(searchParams);
  };

  const data = itinerarySegment.get('content') || [];
  const defaultPageSize = itinerarySegment.get('size') || DEFAULT_PAGE_SIZE;

  const onRowClick = (rowData) => {
    const { itineraryId, segmentId } = rowData;
    const path = `${ITINERARY_INCIDENT_PATH}/itinerary/${itineraryId}/segment/${segmentId}`;
    dispatchPush(path);
  };

  const content = (
    <>
      <ItineraryIncidentSearchForm
        onSubmitWithType={onSubmit}
        initialValues={INITIAL_SEARCH_FORM_VALUES}
        loading={loading}
      />
      <Table
        columns={ITINERARY_SEGMENT_COLUMNS}
        data={data}
        defaultPageSize={defaultPageSize}
        loading={loading}
        manual={false}
        filterable
        onRowClick={onRowClick}
      />
    </>
  );

  return (
    <Content
      content={content}
      title="Incidentes en Itinerarios"
      subtitle="Busca los itinerarios"
      breadcrumbs={breadcrumbs}
    />
  );
};

ItineraryIncidents.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetItinerarySegment: PropTypes.func.isRequired,
  itinerarySegment: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchClearItinerarySegment: PropTypes.func.isRequired,
  dispatchPush: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SupervisionControlUnit }) => ({
  breadcrumbs: [
    ...SupervisionControlUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Incidentes en Itinerarios',
      href: '',
    },
  ],
  itinerarySegment: SupervisionControlUnit.ItineraryIncident.getIn([
    'itinerary',
    'content',
  ]),
  loading: SupervisionControlUnit.ItineraryIncident.getIn([
    'itinerary',
    'loading',
  ]),
});

const mapDispatchToProps = {
  dispatchGetItinerarySegment: getItinerarySegment,
  dispatchClearItinerarySegment: clearItinerarySegment,
  dispatchPush: push,
};

export default connect(mapStateToProps, mapDispatchToProps)(ItineraryIncidents);
